import { connect } from 'react-redux'
import { getDriverLocations, getParentDriverLocations } from 'utils/actions/driverLocations'
import { DriverLocations as DriverLocationsComponent } from './DriverLocations'

const DriverLocations = connect(
  ({
    userDriverLocations: { driverLocations, error, fetching },
    userProfile: { userProfileDetails },
  }) => ({
    userUuid: null,
    parentUserId: userProfileDetails ? userProfileDetails.id : null,
    driverLocations,
    fetching,
    error,
  }),
  { getDriverLocations, getParentDriverLocations }
)(DriverLocationsComponent)

export default DriverLocations
